import React from 'react';
import { FontWeight, Heading, Text } from '@lili/lili-frontend-common';
import format from 'date-fns/format';

interface CorporateResolutionTermsProps {
  accountUBOs: string[];
  businessName: string;
  primaryOwnerName: string;
}

export const CorporateResolutionTerms = ({
  accountUBOs,
  businessName,
  primaryOwnerName,
}: CorporateResolutionTermsProps) => {
  const formattedDate = format(new Date(), 'MMMM dd, yyyy');
  const textClassName = 'text-text-main-primary text-left';
  return (
    <div className='flex flex-col items-start gap-[20px]   '>
      <Heading.H9 fontWeight={FontWeight.MEDIUM} className={textClassName}>
        {`RESOLUTION OF ${businessName || primaryOwnerName}`}
        <Text.H10 fontWeight={FontWeight.REGULAR} className={textClassName}>
          Opening of Bank Account
        </Text.H10>
      </Heading.H9>
      <Heading.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
        {`WHEREAS, the Member(s) has determined it to be in the best interest of ${businessName || primaryOwnerName} (the Company) to establish a
        bank account through Lili App Inc. with Sunrise Banks, N.A. (the Bank);`}
      </Heading.H9>

      <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
        NOW, THEREFORE, BE IT RESOLVED: That the Company execute and deliver to the Bank a duly signed original of this
        banking resolution;
      </Text.H9>

      <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
        FURTHER RESOLVED: That the Member(s) have authorized the Company, through the authorized person(s) below to
        open, maintain, and transact business in the following types of accounts at the Bank: savings, checking and
        other deposit accounts;
      </Text.H9>

      <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
        {`FURTHER RESOLVED: That the following members and/or representatives shall be signatories to said accounts and
        authorized to transact business in said account(s) on behalf of the Company:`}
      </Text.H9>

      <div className='flex flex-col'>
        <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
          Name of Member(s)/Representative(s)
        </Text.H9>
        <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
          {`${accountUBOs.join(', ')}`}
        </Text.H9>
      </div>
      <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
        {`THE UNDERSIGNED hereby certifies that he/she is the duly elected, qualified and acting managing member of the
        Company and that the foregoing resolution was submitted to and approved and adopted by the members at a meeting held
        on ${formattedDate}, and that said resolution is now in full force and effect as permitted under the
        bylaws of the Company and in accordance with the provisions of state law under which the Company was created.`}
      </Text.H9>
      <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
        {`IN WITNESS WHEREOF, the undersigned has hereunto set his hand effective this ${formattedDate}`}
      </Text.H9>

      <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
        {`Resolved by: ${accountUBOs.join(', ')}`}
      </Text.H9>
    </div>
  );
};
